import { graphql } from 'gatsby';
import React from 'react';
import Timeline from '../components/timeline/index';
import DefaultLayout from '../layouts/default-layout';

const TimelineTemplate = props => (
  <DefaultLayout {...props}>
    <Timeline {...props} />
  </DefaultLayout>
);

export default TimelineTemplate;

// eslint-disable-next-line
export const timelinePageQuery = graphql`
  query TimelinePageContentByPath(
    $path: String!,
    $idRegex: String!,
    $isEs: Boolean!,
    $blog: String!,
    $translations: String!
    ) {
    allItemsJson(filter: {path: {eq: $path}}) {
      edges {
        node {
          title
          subtitle
          id
          meta_description
          number_of_bombs
          label
          timeline_group {
            id
            title
            timelines {
              id
              title
              path
              timeline_nav_label
            }
          }
          next_timeline {
            title
            path
            label
            image {
                sizes {
                  original
                  wide_md
                wide_sm
              }
            }
          }
          related_challenge {
            title
          }
          featured_image {
            image {
              sizes {
                hero_lg
                hero_sm
                hero_md
                landscape_md
                landscape_sm
                original
              }
            }
          }
          video {
            url
          }
          ...queryParagraphFields
        }
      }
    }

    ...headerFields @skip(if: $isEs)
    ...footerFields @skip(if: $isEs)
    ...headerFieldsEs @include(if: $isEs)
    ...footerFieldsEs @include(if: $isEs)
    challenges: allItemsJson(
      filter: {content_type: {regex: "/timeline|article|challenge/"}, jsonId: {regex: $idRegex}}
    ) {
      edges {
        node {
          title
          content_type
          path
          related_challenge {
            title
            path
          }
          core_curriculum {
            title
            path
          }
        }
      }
    }
    pages: allItemsJson(
      filter: {content_type: {eq: "page"}, jsonId: {regex: $idRegex}}
    ) {
      edges {
        node {
          title
          content_type
          path
        }
      }
    }
    blog: allItemsJson(filter: {jsonId: {eq: $blog}}) {
      edges {
        node {
          title
          content_type
          path
        }
      }
    }
    translations: allItemsJson(filter: {jsonId: {eq: $translations}}) {
      edges {
        node {
          translations {
            id
            key
            value
          }
        }
      }
    }
    megaMenu: allItemsJson(filter: {content_type: {eq: "mega_menu"}}) {
      edges {
        node {
        id
        jsonId
        content_type
        about {
          link
          title
        }
        our_team {
			    link
			    title
			  }
        projects {
          link
          title
        }
        events {
				  link
				  title
				}
        newsletter {
          link
          title
        }
        latest_stories {
          uri
          title
        }
        magazine {
          link
          title
        }
        educational_resources {
          uri
          title
          image_url
          image_alt
        }
        topics {
          display
          link
          langcode
        }
        translated {
          stories_and_resources
          educational_resources
          latest_stories
          magazine
        }
        lang
        }
      }
    }
  }
`;
